<template>
  <div class="base-table">
    <el-table
      v-loading="loading"
      :data="data"
      :height="height"
      :max-height="maxHeight"
      :empty-text="emptyText"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >
      <el-table-column
        v-if="showIndex"
        type="index"
        label="序号"
        width="60"
        align="center"
      />

      <el-table-column
        v-if="showSelection"
        type="selection"
        width="55"
        align="center"
      />

      <slot />

      <el-table-column
        v-if="showActions"
        label="操作"
        :width="actionsWidth"
        align="center"
      >
        <template slot-scope="scope">
          <slot name="actions" :row="scope.row" :index="scope.$index" />
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="showPagination"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    height: [String, Number],
    maxHeight: [String, Number],
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    showSelection: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    actionsWidth: {
      type: [String, Number],
      default: 200
    },
    showPagination: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    }
  },
  methods: {
    handleSelectionChange (selection) {
      this.$emit('selection-change', selection)
    },
    handleSortChange (sort) {
      this.$emit('sort-change', sort)
    },
    handleSizeChange (size) {
      this.$emit('size-change', size)
    },
    handleCurrentChange (page) {
      this.$emit('current-change', page)
    }
  }
}
</script>

<style scoped>
.base-table {
  width: 100%;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseTable.vue